function requirePayload(response) {
    if (response.payload == null)
        throw new Error("No data received from the server");
    return response.payload;
}
export async function createStaffInvite(client, clubId, request) {
    return requirePayload((await client.post(`/clubs/${clubId}/staff/invites`, request)).data);
}
export async function getStaffInvites(client, clubId) {
    return requirePayload((await client.get(`/clubs/${clubId}/staff/invites`)).data);
}
export async function revokeStaffInvite(client, clubId, inviteId) {
    return requirePayload((await client.delete(`/clubs/${clubId}/staff/invites/${inviteId}`)).data);
}
export async function getStaff(client, clubId) {
    return requirePayload((await client.get(`/clubs/${clubId}/staff`))
        .data);
}
export async function disableStaff(client, clubId, memberId) {
    return requirePayload((await client.post(`/clubs/${clubId}/staff/${memberId}/disable`)).data);
}
export async function enableStaff(client, clubId, memberId) {
    return requirePayload((await client.post(`/clubs/${clubId}/staff/${memberId}/enable`)).data);
}
export async function acceptStaffInvite(client, inviteId, request) {
    return requirePayload((await client.post(`/staff-invites/${inviteId}/accept`, request)).data);
}
